module.exports = __webpack_public_path__ + "media/highclass/top-image-pc-96f4823a.webp";